{
	"meta": {
		"title": "Contacto — UpSquad",
		"description": "Ponte en contacto con el equipo de UpSquad — solicitudes de funciones, reportes de errores, eliminación de cuenta o consultas generales."
	},
	"hero": {
		"eyebrow": "Contacto",
		"title": "Hablemos.",
		"title_accent": "",
		"subtitle": "Envíanos un mensaje y te responderemos en breve. Solemos contestar en un día hábil."
	},
	"form": {
		"name_label": "Tu nombre",
		"name_placeholder": "Juana Pérez",
		"email_label": "Correo electrónico",
		"email_placeholder": "tu@empresa.com",
		"company_label": "Organización (opcional)",
		"company_placeholder": "Acme Foundation",
		"subject_label": "¿Con qué te ayudamos?",
		"subject_placeholder": "Elige un asunto",
		"message_label": "Mensaje",
		"message_placeholder": "Cuéntanos un poco más...",
		"submit": "Enviar mensaje",
		"submitting": "Enviando...",
		"required": "Obligatorio",
		"subjects": {
			"feature_request": "Solicitud de función",
			"bug_report": "Reporte de error",
			"account_removal": "Eliminar mi cuenta (RGPD)",
			"general": "Consulta general"
		},
		"gdpr_notice": "Procesamos las solicitudes de eliminación de cuenta en un plazo de 30 días, conforme al RGPD."
	},
	"info": {
		"title": "Otras formas de contactarnos",
		"email_label": "Correo",
		"linkedin_label": "LinkedIn",
		"x_label": "X (Twitter)",
		"office": "3618 Walker Ave · Memphis, TN 38152"
	},
	"quick": {
		"demo": {
			"title": "Reserva una demo de 30 minutos",
			"body": "Ve UpSquad en vivo con nuestro equipo. Configuramos un sandbox para tu organización durante la llamada.",
			"cta": "Elige un horario en Calendly"
		},
		"help": {
			"title": "Centro de ayuda",
			"body": "Guías de configuración, integraciones y tutoriales — buscables y siempre actualizados."
		}
	}
}
